import { Injectable } from '@angular/core';

import { Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Http, Headers, RequestOptions } from '@angular/http';
import { ToastController } from 'ionic-angular';

import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";
//import { MyLocation } from '@ionic-native/google-maps';
import { Geoposition } from '@ionic-native/geolocation';


@Injectable()
export class UserData {
  loggedin : boolean = false;


  email : string = '';
  p : string = '';
  userid : number = -1;
  usergroup_id : number = -1;
  admin : number = -1; 
  jwt: string = '';
  storeimageslocally:boolean = true;
  imagequality:number = 60;
  editmode:boolean = false;
  loadoldpb:boolean = false;
  kontrollwidget:number = 2;
  
  acl:any;
  employees:any;
  actposition:Geoposition;
  mandate_mandid: number;
  

  constructor(public events: Events, public storage: Storage, public http: Http, public toastCtrl: ToastController, public common: CommonData) {
    this.imagequality = 60;
    this.mandate_mandid = -1;
  }


  login(email, password) {
    if (this.loggedin) {
      // already loaded data
      return Promise.resolve([this.email, this.userid, this.admin, this.jwt]);
    }

    
    return new Promise(resolve => {
      let body = JSON.stringify({
        email: email,
        p: password
      });

      this.http.post(this.common.loginurl,body)
        .subscribe(data => {
          let response = data.json();

          
          if(response.success === "true"){
            //toastr.success('Login erfolgreich')
            this.loggedin = true;
            this.setUserdata(email,password, response.token);
            this.admin = response.admin;
            this.userid = response.userid;
            this.email = response.email;
            this.usergroup_id = response.usergroup_id;            
            this.jwt = response.token;
            this.mandate_mandid = response.mandate_mandid;
            //console.log(response);

            this.storage.set("storeimageslocally", true);
            this.storage.set("editmode", false);
            this.storage.set("kontrollwidget", 2);
            this.storage.set("loadoldpb", false);
            //this.storage.set("imagequality", 40);
        


            let toast = this.toastCtrl.create({
              message: 'Login erfolgreich',
              position: 'top',
              cssClass: 'toast-success',
              duration: 3000
            });
            toast.present(); 

            this.events.publish('user:login');      
          }
          else{
            let toast = this.toastCtrl.create({
              message: 'Login nicht erfolgreich',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();            
          }
        resolve([this.email, this.userid, this.admin, this.jwt]);          
        }, error => {
          console.log('HTTP Error, no answer');
            let toast = this.toastCtrl.create({
              message: 'Login nicht erfolgreich',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();    
      });
    });

  }
  loginToken() {
    //darf erst nach checkLoginToken aufgerufen werden
    return new Promise(resolve => {
      let body = JSON.stringify({
        token: this.jwt
      });

      this.http.post(this.common.loginurl,body)
        .subscribe(data => {
          let response = data.json();
          //console.log('loginToken result:');
          //console.log(response);
          if(response.success === "true"){
            //toastr.success('Login erfolgreich')
            this.loggedin = true;

            this.jwt = response.token;
            this.setUserdata("","", response.token);
            this.userid = response.userid;
            this.email = response.email;
            this.usergroup_id = response.usergroup_id;
            this.mandate_mandid = response.mandate_mandid;

            this.getStoreimageslocally();
            this.getEditmode();
            this.getKontrollwidget();
            this.getLoadoldpb();
            //this.getImagequality();
            let toast = this.toastCtrl.create({
              message: 'Login erfolgreich',
              position: 'top',
              cssClass: 'toast-success',
              duration: 3000
            });
            toast.present(); 

            this.events.publish('user:login');      
          }
          else{
            let toast = this.toastCtrl.create({
              message: 'Login nicht erfolgreich',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();            
          }
        resolve([this.jwt]);          
        }, error => {
          console.log('HTTP Error, loginToken no answer');
          console.log(error);
      });
    });

  }  

  loadACL() {
    if (this.acl) {
      return Promise.resolve(this.acl);
    }
    return new Promise(resolve => {
      if(this.loggedin){
        this.http.get(this.common.baseurl+'users/acl?token='+this.jwt).subscribe(res => {
          this.acl = res.json().data;
          //console.log('acl:'+res);
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer acl user-data.ts');
          console.log(error);
      });

      }
    });
  }
  loadEmployees() {
    if (this.employees) {
      return Promise.resolve(this.employees);
    }
    return new Promise(resolve => {
      if(this.loggedin){
        this.http.get(this.common.baseurl+'users/employees?token='+this.jwt).subscribe(res => {
          this.employees = res.json().data;
          //console.log(res.json());
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer employees user-data.ts');
          console.log(error);
      });

      }
    });
  }
  isAllowed(module,action){
    if(this.acl == null){
      return false;
    }
    
    for(let i=0; i<this.acl.length; i++){
      if(this.acl[i]['module_id'] == module){
        if(this.acl[i][action] == 1)
        {
          return true;
        }
        else{
          return false;
        }
      }
    }//for
    return false;
  }   

  employeeNameById(benutzer_id){
    for(let i=0; i<this.employees.length; i++){
      if(this.employees[i]['userid'] == benutzer_id){
        return this.employees[i]['name'];
      }
    }//for    
    return benutzer_id;
  }

  // return a promise
  checkLogin() {
   return Promise.all([
      this.getEmail(),
      this.getPass()
    ]).then(data => {
      if(this.email && this.p){
        return this.login(this.email, this.p);
      }
      else{
        //return false;
      }
    });
  }
  checkLoginToken() {
   return Promise.all([
      this.getToken()
    ]).then(data => {
      //console.log("checkLoginToken:"+this.jwt);
      if(this.jwt){
        return this.loginToken();
      }
      else{
        console.log('TODO kein Token vorhanden')
        //return false;
      }
    });
  }


  setUserdata(email, pass,token){
    //this.email = email;
    //this.p = pass;
    //this.storage.set("email", email);
    //this.storage.set("p", pass);
    this.storage.set("token", token);
  }

  getEmail() {
    return this.storage.get("email").then(email => {
      this.email = email;
    });
  }
  getToken() {
    return this.storage.get("token").then(token => {
      //console.log("got token");
      this.jwt = token;
    });
  }
  getStoreimageslocally() {
    return this.storage.get("storeimageslocally").then(data => {
      //console.log("got token");
      this.storeimageslocally = data;
    });
  }  
  getImagequality() {
    return this.storage.get("imagequality").then(data => {
      //console.log("got token");
      this.imagequality = data;
    });
  }    
  setImagequality(value) {
    this.storage.set("imagequality", value);
  }    

  getEditmode() {
    return this.storage.get("editmode").then(data => {
      //console.log("got token");
      this.editmode = data;
    });
  }       
 
  setEditmode(value) {
    this.storage.set("editmode", value);
  }  

  getLoadoldpb() {
    return this.storage.get("loadoldpb").then(data => {
      //console.log("got token");
      this.loadoldpb = data;
    });
  }       
 
  setLoadoldpb(value) {
    this.storage.set("loadoldpb", value);
  }  
  
  getKontrollwidget() {

    return this.storage.get("kontrollwidget").then(data => {
      this.kontrollwidget = data;
    });
  }       
 
  setKontrollwidget(value) {
    this.storage.set("kontrollwidget", value);
  }    
  
    
  setStoreimageslocally(value) {
    this.storage.set("storeimageslocally", value);
  }    
  
  getPass() {
    return this.storage.get("p").then(p => {
      this.p = p;
    });
  }

  signup(username) {
    this.events.publish('user:signup');
  }

  logout() {
    this.loggedin = false;
    this.storage.remove('email');
    this.storage.remove('p');
    this.storage.remove('token');
    this.storage.remove('storeimageslocally');
    this.storage.remove('editmode');
    this.storage.remove('kontrollwidget');
    this.storage.remove('loadoldpb');
    this.acl = {};
    this.jwt = '';    
    this.events.publish('user:logout');
  }



}



// WEBPACK FOOTER //
// ./src/providers/user-data.ts